const { setInitialised } = window.BAO.Carousel.plugins

class TimelineMainSection extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.setTallestSlideHeight()
    this.carousel = this.setupCarousel()

    this.setupDates()
  }

  setupListeners () {
    super.setupListeners()

    // on browser resize, update the tallest slide height
    window.addEventListener('resize', () => {
      this.setTallestSlideHeight()
    })
  }

  setTallestSlideHeight () {
    const tallestSlideHeight = this.getMaxHeight(this.els.itemBody.elements)
    this.els.slides.element.style.setProperty(
      '--carouselImageHeight',
      `${tallestSlideHeight}px`,
    )
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        drag: true,
        vertical: true,
        rubberband: false,
        slides: {
          perView: 1,
          spacing: 30,
        },
        slideChanged: this.onSlideChanged,
      },
      [setInitialised()],
    )
  }

  setupDates () {
    this.els.dates.elements.forEach((slider) => {
      const thumbnailItems = slider.querySelectorAll(
        '.sec-FiftyFiftyTimeline_ItemsDatesItem',
      )
      thumbnailItems.forEach((item) => {
        item.addEventListener('click', () => {
          item.classList.remove('sec-FiftyFiftyTimeline_ItemsDatesItem-active')

          const itemIndexValue = item
            .querySelector('.sec-FiftyFiftyTimeline_ItemsDatesItemTrigger')
            .getAttribute('data-slide')

          this.carousel.moveToIdx(parseInt(itemIndexValue))

          // Remove active class from all thumbnails
          thumbnailItems.forEach((thumb) => {
            thumb.classList.remove(
              'sec-FiftyFiftyTimeline_ItemsDatesItem-active',
            )
          })

          // Add active class to the clicked thumbnail
          item.classList.add('sec-FiftyFiftyTimeline_ItemsDatesItem-active')
        })
      })
    })
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-current', index === currentSlide)
    })

    this.updateDates(currentSlide)
  }

  updateDates (currentSlide) {
    this.els.dates.elements.forEach((slider) => {
      const thumbnailItems = slider.querySelectorAll(
        '.sec-FiftyFiftyTimeline_ItemsDatesItem',
      )
      thumbnailItems.forEach((item) => {
        const itemIndexValue = parseInt(
          item
            .querySelector('.sec-FiftyFiftyTimeline_ItemsDatesItemTrigger')
            .getAttribute('data-slide'),
        )

        if (currentSlide === itemIndexValue) {
          item.classList.add('sec-FiftyFiftyTimeline_ItemsDatesItem-active')
        } else {
          item.classList.remove('sec-FiftyFiftyTimeline_ItemsDatesItem-active')
        }
      })
    })
  }

  getMaxHeight (elements) {
    return Math.max(...elements.map((element) => element.offsetHeight))
  }
}

class TimelineDates extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
  }
}

if (!customElements.get('timeline-main-carousel')) {
  customElements.define('timeline-main-carousel', TimelineMainSection)
}

if (!customElements.get('timeline-dates')) {
  customElements.define('timeline-dates', TimelineDates)
}
